export const allFeatureTexture = (data) => {
    return async (dispatch) => {
        await dispatch({type:"GET_FEATURE", payload:data});
    }
}